import { IGetters } from './getters.types'
import { IWorkspaceData, ITechnicalApplication, IApplicationSubmit, IApplicationBudget, IApplicantDueDeligence } from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants';
import {Utilities as _utils} from '@/shared/utilities';

export const getters: IGetters = {

    /** get the root template based on the language selected */
    rootTemplate (state: IWorkspaceData): any {
        return state.templates[state.language] || {}
    },

    /** selected initiative call */
    getCallId(state: IWorkspaceData): number {
        return state.selectedCall     
    },
    /** project title */
    projectTitle(state: IWorkspaceData): string {
        if(state.conceptNote && state.conceptNote.Title){
            return (state.conceptNote.Title.length > 40) ? `${state.conceptNote.Title.substring(0,40)}...` : state.conceptNote.Title;
        } else {
            return '';
        }        
    },

    /** get the technical application (schema | data | selected menu) */
    technicalApplication(state: IWorkspaceData): ITechnicalApplication {
        return state.technicalApplication;
    },

    /** get the application budget (schema | data) */
    applicationBudget(state: IWorkspaceData): IApplicationBudget {
        return state.applicationBudget
    },

    /** get the application due diligence (schema | data) */
    appDueDiligence(state: IWorkspaceData): IApplicantDueDeligence {
        return state.applicantDueDeligence
    },

    /** technical application sub menu */
    techAppKey(state: IWorkspaceData): any {
        return state.subMenu.technicalApplication;
    },

    /** sub menu */
    ddKey(state: IWorkspaceData): any {
        return state.subMenu.applicantDueDeligence;
    },

    /** sub menu */
    lfKey(state: IWorkspaceData): any {
        return state.subMenu.logFramework;
    },
    /** get the list of indicators */
    indicators(state: IWorkspaceData): any {
        return state.indicators;
    },

    conceptNoteId(state: IWorkspaceData): any {
        return state.selectedConceptNote || state.conceptNote.ConceptNoteId
    },

    maxAmountPossible(state: IWorkspaceData) {
        return state.conceptNote.BudgetAmount
    },
    grantType(state: IWorkspaceData) {
        return state.conceptNote.GrantTypeId
    },
    /** BUdget currency */
    currency(state: IWorkspaceData): any {
        return state.conceptNote.BudgetCurrency;
    },
    projectYrs(state: IWorkspaceData): any {
        let duration = []; //, strt: number, end: number;
        let k=2;
        if (state.data.projectStartDate && state.data.projectEndDate) {
            duration.push('Year1');
            const diff = _utils.monthDiff(state.data.projectStartDate, state.data.projectEndDate);
            // end =  new Date(state.data.projectEndDate).getFullYear();
            // strt = new Date(state.data.projectStartDate).getFullYear();
            // for (let i = strt, k = 1; i <= end; i++, k++) {
            //     duration.push(`Year${k}`);
            // }
            for (let m = 1; m < diff; m++) {
                if (m % 12 === 0) {
                    duration.push(`Year${k}`);
                    k += 1;
                }
            }
        }
        return duration;
    },
    reportingFrequency(state: IWorkspaceData) {
        let val = 0;
        if (state.conceptNote.ReportingFrequency) {
            switch (state.conceptNote.ReportingFrequency) {
                case _app.reportingFrequency.Quartertly:
                    val = 4;
                    break;
                case _app.reportingFrequency.HalfYearly:
                    val = 2;
                    break;
                case _app.reportingFrequency.Yearly:
                    val = 1;
                    break;
                default:
                    break;
            }
        }
        return val;
    },
    /** Is Grant type RAG */
    isRAGTemplate(state: IWorkspaceData): boolean {
        if(state.templates && state.templates.IsRAGTemplate){
            return true;
        } else {
            return false;
        }        
    },

    /** get the application due diligence (schema | data) */
    appSubmit(state: IWorkspaceData): IApplicationSubmit {
        return state.applicationSubmit
    },


}